import { CustomExceptionResponse } from "@rms-types/exceptions";
import { AxiosError } from "axios";

export const getErrorMessage = (error: AxiosError<CustomExceptionResponse> | undefined, genericMessage: string) => {
  if (!error) {
    return genericMessage;
  }

  if (error.response && error.response.status >= 500) {
    return "Internal Server Error. Our team has been notified";
  }

  return error.response?.data?.message || genericMessage;
};
